// Values and labels for ticket fields, shared by the Tickets list, ticket detail and entity Tickets tabs.
// Option values are the ones the legacy Tickets page sent to the API.

export const TEAM_OPTIONS = [
  { value: 'dba', label: 'DBA' },
  { value: 'devops', label: 'DevOps' },
  { value: 'enterprise', label: 'Enterprise' },
];

// Filter values must match the stored status exactly (Jotform vocabulary for normal tickets).
export const STATUS_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'preview', label: 'Preview' },
  { value: 'Opened', label: 'Opened' },
  { value: 'InProgress', label: 'In progress' },
  { value: 'Waiting4User', label: 'Waiting for user' },
  { value: 'Waiting4Agent', label: 'Waiting for agent' },
  { value: 'Resolved', label: 'Resolved' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'waiting_for_approval', label: 'Waiting for approval' },
  { value: 'creation_failed', label: 'Creation failed' },
  { value: 'creating', label: 'Creating in Jotform' },
  { value: 'promoting', label: 'Opening in Jotform' },
];

// What a status change writes — values must match Jotform's exact vocabulary.
export const STATUS_CHANGE_OPTIONS = [
  { value: 'Opened', label: 'Opened' },
  { value: 'InProgress', label: 'In progress' },
  { value: 'Waiting4User', label: 'Waiting for user' },
  { value: 'Waiting4Agent', label: 'Waiting for agent' },
  { value: 'Resolved', label: 'Resolved' },
  { value: 'Cancelled', label: 'Cancelled' },
];

export const PRIORITY_OPTIONS = ['Urgent', 'High', 'Medium', 'Low'].map((p) => ({ value: p, label: p }));

export const MODE_OPTIONS = [
  { value: 'normal', label: 'Normal' },
  { value: 'preview', label: 'Preview' },
];

// Ticket flow_type of image tickets; offered only by the Tickets list filter, not by the host flows.
export const IMAGE_FLOW_OPTION = { value: 'container-image', label: 'Container image' };

const TYPES = { 'host-based': 'Host', 'package-based': 'Package', 'cve-based': 'CVE', 'image-based': 'Container image' };
export const isImageTicket = (t) => t?.ticket_type === 'image-based';
const capitalize = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export const ticketTypeLabel = (type) => TYPES[type] || capitalize(type) || null;
export const ticketModeLabel = (mode) => MODE_OPTIONS.find((m) => m.value === String(mode).toLowerCase())?.label || capitalize(mode) || null;
export const ticketName = (t) => t.ticket_name || `Ticket ${t.id}`;
export const isPreview = (t) => String(t?.mode || '').toLowerCase() === 'preview';
// The external Jotform ticket URL, derived from the answer ID.
export const jotformUrl = (t) => {
  if (isPreview(t)) return null;
  if (t?.ticket_url) return t.ticket_url;
  if (t?.jotform_answer_id) return `https://www.jotform.com/answers/${t.jotform_answer_id}`;
  return null;
};
